/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Save_Project_Cancelled_ErrorInputs */

const en_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save process cancelled by user`)
};

const fr_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processus d'enregistrement annule par l'utilisateur`)
};

const de_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichervorgang vom Benutzer abgebrochen`)
};

const it_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio del processo annullato dall'utente`)
};

const ru_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Процесс сохранения отменен пользователем`)
};

const es_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceso de guardado cancelado por el usuario`)
};

const zh_cn2_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户取消了保存过程`)
};

const ja_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存プロセスはユーザーによってキャンセルされました`)
};

const hi_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता द्वारा सेव प्रक्रिया रद्द कर दी गई`)
};

const pt_pt2_shortcut_keys_save_project_cancelled_error = /** @type {(inputs: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O processo de salvamento foi cancelado pelo usuário.`)
};

/**
* | output |
* | --- |
* | "Save process cancelled by user" |
*
* @param {Shortcut_Keys_Save_Project_Cancelled_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_save_project_cancelled_error = /** @type {((inputs?: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Save_Project_Cancelled_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_save_project_cancelled_error(inputs)
	if (locale === "de") return de_shortcut_keys_save_project_cancelled_error(inputs)
	if (locale === "it") return it_shortcut_keys_save_project_cancelled_error(inputs)
	if (locale === "ru") return ru_shortcut_keys_save_project_cancelled_error(inputs)
	if (locale === "es") return es_shortcut_keys_save_project_cancelled_error(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_save_project_cancelled_error(inputs)
	if (locale === "ja") return ja_shortcut_keys_save_project_cancelled_error(inputs)
	if (locale === "hi") return hi_shortcut_keys_save_project_cancelled_error(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_save_project_cancelled_error(inputs)
	return en_shortcut_keys_save_project_cancelled_error(inputs)
});